import { render, staticRenderFns } from "./ReviewDataModal.vue?vue&type=template&id=2fca4bf8"
import script from "./ReviewDataModal.vue?vue&type=script&lang=ts"
export * from "./ReviewDataModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports